<template>
    <Modal v-on:close="onModalClose" v-if="showModal">
      <template v-slot:body>
        <h1>Signing Up</h1>
        <div v-if="errorText === ''" class="spinner P(abs) Top(50%)"></div>
        <div v-else class="P(abs) Top(50%)">{{errorText}}</div>
      </template>
    </Modal>
    <router-view
        v-if="routeName !== 'Authenticate'"
        name="replace"
        v-bind:signup-data="signupData"
        v-on:submit="(e) => routeName === 'SignupProfile' ? onSignupFormSubmit(e) : null"
    />
    <div v-else class="D(flex) Fd(column) W(100%) H(100%)">
        <!-- <h1>Login Page</h1>
        <form v-on:submit="onSubmit">
            <ul>
                <li>
                    <label for="">User Name: </label>
                    <input type="text" v-model="loginInfo.user_name" />
                </li>
                <li>
                    <label for="">Password: </label>
                    <input type="text" v-model="loginInfo.password" />
                </li>
                <li>
                    <input type="submit" title="Login" />
                </li>
            </ul>
        </form> -->
        <div class="login__section">
            <Image v-bind:altString="'tinder logo'" v-bind:imgSrc="'/tinder.ico'" v-bind:width="'36px'" v-bind:height="'36px'"/>
            <h1 class="heading">GET STARTED</h1>
            <p class="Ta(center) mb(12px)">By clicking Log In, you agree to our Terms. Learn how we process your data in our Privacy Policy and Cookie Policy.</p>
            <button
                class="button D(flex) Fd(row) Al(center) Cur(p)"
            >
                <span class="button__icon">
                    <img src="/icon/google-logo.svg" alt="google logo">
                </span>
                <span class="button__label">LOGIN WITH GOOGLE</span>
            </button>
            <button v-bind:class="{'Jc(center)': isLogging}"
                class="button D(flex) Fd(row) Al(center) Cur(p)"
                @click="loginFB"
            >
                <span v-if="!isLogging" class="button__icon">
                    <img src="/icon/facebook-logo.svg" alt="facebook logo">
                </span>
                <span v-if="!isLogging" class="button__label">LOGIN WITH FACEBOOK</span>
                <div v-if="isLogging" class="spinner"></div>
            </button>
            <hr class="W(100%)">
            <form class="login__form D(flex) Fd(column) Al(center) W(100%)" v-on:submit="onSubmit">
                <input type="text" class="login__input" v-model.trim="loginInfo.user_name" placeholder="Username or email" />
                <input type="password" class="login__input" v-model="loginInfo.password" placeholder="Password" />
                <div v-if="loginError" class="error-text">{{ loginError }}</div>
                <button type="submit" v-bind:disabled="isLoginDisabled"
                    :class="{ 'button--brand': hasLoginCredentials }"
                    class="button D(flex) Fd(row) Al(center) Jc(center) Cur(p)">
                    <span v-if="!isSubmitting" class="button__label">LOG IN</span>
                    <div v-if="isSubmitting" class="spinner"></div>
                </button>
            </form>
            <p class="Ta(center) mb(12px)">
                Don't have an account?
                <router-link :to="{ name: 'SimpleSignup' }" class="login__link">Create account</router-link>
            </p>
            <h1 class="heading">COMING SOON IN 2023!</h1>
            <div class="logo__container D(flex) W(100%) Fd(row) Jc(space-between) Al(center)">
                <Image v-bind:altString="'app store logo'" v-bind:imgSrc="'/img/appstore-logo.png'" style="height:48px;object-fit:contain"/>
                <Image v-bind:altString="'app store logo'" v-bind:imgSrc="'/img/googleplay-logo.png'" style="height:65px;object-fit:contain"/>
            </div>
        </div>
        
    </div>
</template>
<script >
import { ref } from "vue";
import axios from "axios";
import Image from "./Image.vue"
import { mapActions, mapGetters } from "vuex";
import Modal from './Modal.vue';
export default {
    name: "Login",
    components: {
        Image,
        Modal,
    },
    setup() {
        const loginInfo = ref({
            user_name: "unclebob",
            password: "1234",
        });
        return {
            loginInfo,
            fbAccessToken: FB.getAuthResponse(),
            signupData: null,
        };
    },
    data(){
        return{
            test: 'hello',
            isLogging: false,
            isSubmitting: false,
            showModal: false,
            errorText: '',
            loginError: '',
        }
    },
    computed: {
        routeName: function () {
            return this.$route.name;
        },
        isLoginDisabled: function () {
            return this.isSubmitting || !this.hasLoginCredentials;
        },
        hasLoginCredentials: function () {
            return !!(this.loginInfo.user_name && this.loginInfo.password);
        },
    },
    methods: {
        //------vi du: ...mapActions({usersFunction: 'users/addNewUser', parrent: 'test'}),
        ...mapActions({
            addNewUser: "users/addNewUser",
            unLoadUser: "users/unLoadUser",
            setProfileImages: "users/setProfileImages",
            setToken: "users/setToken",
            doFbAuth: "doFbAuth",
            doSignup: "doSignup",
            doGet: "doGet"
        }),
        ...mapGetters("users", ["isAuthenticated", "getMe"]),
        async loginFB() {
            if(this.isLogging){
                return;
            }

            this.isLogging = true;
            const authResponse = FB.getAuthResponse();
            if (!authResponse) {
                FB.login(this.loginCallback, {
                    scope: "email,public_profile",
                    return_scopes: true,
                });
            } else {
                FB.api("/me/permissions", "delete", null, () =>{ FB.logout(); console.log(this.isLogging = false)} );
            }
        },
        afterLoginCallback: function (me, authResponse) {
            console.log("afterlogincallback:", me);
            this.signupData = me;
            this.fbAccessToken = authResponse.accessToken;
            this.$router.push({ name: "SignupProfile" });
        },
        loginCallback: async function (response) {
            let authResponse = response.authResponse;
            if (authResponse) {
                const res = await this.doFbAuth(authResponse.accessToken);
                if (res !== null) {
                    if (res.accessToken) {
                        this.setToken(res.accessToken);
                        this.$router.push({ name: "MakeFriends" });
                    } else {
                        FB.api(
                            "/me",
                            "get",
                            {
                                access_token: authResponse.accessToken,
                                fields: "email,name,picture",
                            },
                            (me) => this.afterLoginCallback(me, authResponse)
                        );
                    }
                }
            }
            else{
                this.isLogging = false;
            }
            console.log("login call back:", response);
        },
        onSignupFormSubmit(data){
            this.showModal = true;
            data['accessToken'] = this.fbAccessToken;
            this.handleSignup(data);
        },
        async handleSignup(data){
            const res = await this.doSignup(data);
            if(res != null){
                if(res.isSuccess){
                    this.setToken(res.accessToken);
                    this.$router.push({ name: "MakeFriends" });
                }
                else{
                    this.errorText = res.message;
                }
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            if (this.isSubmitting) {
                return;
            }
            this.loginError = '';
            if (!this.loginInfo.user_name || !this.loginInfo.password) {
                this.loginError = 'Please enter your username and password.';
                return;
            }
            this.isSubmitting = true;
            const objectParam = {
                userName: this.loginInfo.user_name,
                password: this.loginInfo.password,
            };
            try {
                let response = await axios.post(
                    process.env.VUE_APP_HOST_URL +"/api/users/login",
                    objectParam
                );

                this.setToken(response.data.accessToken);

                console.log("after login, going to App... ", response.data);
                this.$router.push({ name: "MakeFriends" });
            } catch (err) {
                console.log("error while login: ", err);
                this.loginError = err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : "Login failed. Please try again.";
            } finally {
                this.isSubmitting = false;
            }
        },
        async init() {
            console.log("init login.vue");
            if (this.$route.params.action == "login") {
                const isAuthenticated =
                    this.$store.getters["users/isAuthenticated"];
                if (isAuthenticated) {
                    this.$router.push({ name: "MakeFriends" });
                }
            } else if (this.$route.params.action == "logout") {
                this.unLoadUser();
                this.$router.push({ name: "Home" });
            }
        },
        onModalClose: function(){
            this.showModal = false;
            this.errorText = '';
        }
    },
    created: function () {
    },
    mounted: function () {
        console.log('mounted login')
        this.showModal = false;
        this.init();
    },
};
</script>

<style scoped>
.spinner{
    width: 45px;
    height: 45px;
    border: currentColor 5px solid;
    border-color: currentColor currentColor transparent transparent;
    border-radius: 50%;
    animation: spin 0.85s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.heading{
    margin-top: 30px;
    text-align: center;
    font-style: italic;
}

.button{
    width: 315px;
    min-height: 54px;
    border-radius: 100px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.button:not(.button--brand){
    background-color: white;
    border: gray 1px solid;
    color: gray;
}

.button:not(.button--brand):hover{
    border: black 1px solid;
    color: black;
}

.button:disabled{
    cursor: default;
}

.button:not(.button--brand):disabled{
    opacity: 0.6;
}

.button__icon{
    width: 15%;
}

.button__label{
    width: 75%;
    font-size: 0.85rem;
}

@media screen and (max-width: 500px) {
    .button{
        width: 75% !important;
    }
}

input[type="submit"] {
    float: right;
}
form {
    margin: 0 auto;
}
li {
    list-style: none;
}
label {
    max-width: 50px;
    text-align: right;
}

.login__section{
    margin-top: 20px;
    width: 60%;
    max-width: 500px;
    height: 100%;
    align-self: center;
    justify-self: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.login__form{
    gap: 10px;
}

.login__input{
    width: 90%;
    max-width: 315px;
    height: 44px;
    padding-left: 14px;
    padding-right: 14px;
    border: gray 1px solid;
    border-radius: 100px;
    font-size: 0.95rem;
    box-sizing: border-box;
}

.login__input:hover,
.login__input:focus{
    border: black 1px solid;
    outline: none;
}

.login__link{
    color: var(--blue50);
    font-weight: bold;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.login__link:visited{
    color: var(--blue50);
}

.login__link:hover{
    color: var(--blue40);
}
</style>

<style scoped>
@media screen and (max-width: 470px) {
    .logo__container{
        flex-direction: column;
    }
}
</style>